import React, { Fragment, PureComponent } from 'react';
import styled from 'styled-components';

// @ts-ignore FIXME: Try `npm install @types/rc-form` if it exists or a... Remove this comment to see the full error message
import { createForm, formShape } from 'rc-form';
import TextField from '../../SolvPatternLibrary/TextField';
import Button, { ButtonVariations } from '../../SolvPatternLibrary/Button';
import { colors } from '../../../constants/colors';
import { fontSize, fontFamily } from '../../../constants/text';
import { biggerThanOrEqualTo } from '../../../core/util/styledComponents';
import {
  BUTTON_STATUS_ERROR,
  BUTTON_STATUS_INITIAL,
  BUTTON_STATUS_LOADING,
  BUTTON_STATUS_SUCCESS,
} from '../../SolvPatternLibrary/Button/TransitionButton';

import { PRIMARY_RATING } from './PrimaryRatingSelector';

export const FREE_RESPONSE_FIELD = 'freeResponse';

const Divider = styled.div`
  height: 1px;
  background-color: ${colors.dorianGrey};
  display: block;
  margin: 0 20px;

  ${biggerThanOrEqualTo.sm`
    width: 100%;
    margin: 0 auto;
  `}
`;

const Root = styled.form`
  padding: 26px 20px;
`;

const Title = styled.h1`
  margin: 0 auto 20px;
  display: block;
  font-family: ${fontFamily.bold};
  font-size: ${fontSize.large};
  color: ${colors.blueMonday};
`;

const DescriptionField = styled(TextField)`
  max-width: 500px;
  margin: 0 auto;
  background: ${colors.theWhiteAlbum};
  overflow: hidden;

  & .details-root {
    height: 90px;
  }

  & .input-root {
    height: 90px !important;
    text-indent: 0;
    padding: 12px 16px;
  }
`;

const SubmitButton = styled(Button)`
  max-width: 500px;
  margin: 28px auto 20px auto;
`;

type Props = {
  form: formShape;
  submit: (...args: any[]) => any;
  maryMagicSurvey?: any;
  location?: any;
};

class FreeResponseForm extends PureComponent<Props> {
  get buttonStatus() {
    switch (this.props.maryMagicSurvey.submissionStatus) {
      default:
      case undefined:
        return BUTTON_STATUS_INITIAL;
      case 'error':
        return BUTTON_STATUS_ERROR;
      case 'submitting':
        return BUTTON_STATUS_LOADING;
      case 'success':
        return BUTTON_STATUS_SUCCESS;
    }
  }

  descriptionProps = {
    ...this.props.form.getFieldProps(FREE_RESPONSE_FIELD),
    id: FREE_RESPONSE_FIELD,
    placeholder: "We'd love to hear how we can make Solv better...",
    onChange: ({ target: { id, value } }: any) => this.props.form.setFieldsValue({ [id]: value }),
  };

  handleSubmit = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    const { form, submit } = this.props;

    submit(form.getFieldsValue());
  };

  render() {
    const { maryMagicSurvey } = this.props;
    return (
      <>
        <Divider />

        <Root onSubmit={this.handleSubmit}>
          <Title>Do you have any questions, comments or concerns?</Title>

          <DescriptionField
            multiline
            fullWidth
            InputProps={{ classes: { root: 'details-root' } }}
            classes={{ inputInput: 'input-root' }}
            {...this.descriptionProps}
          />

          <SubmitButton
            type="submit"
            animationEnabled
            status={this.buttonStatus}
            disabled={!maryMagicSurvey[PRIMARY_RATING]}
            variation={ButtonVariations.pinkPrimary}
          >
            Done
          </SubmitButton>
        </Root>
      </>
    );
  }
}

export default createForm()(FreeResponseForm);
